import React from 'react'
import { Outlet } from 'react-router-dom';

const ForecastMonthStatMngPage = () => {
    return (
        <Outlet />
    )
}

export default ForecastMonthStatMngPage